import React from "react";
import "./Rank.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon, SearchBar } from "antd-mobile";
import qs from "qs";
import Loading from "../../components/Loading";
const mapping=[
  {
    eventId:'685108179250',
    rankResid:'685990220046',
    rankAllResid:'686223516937',
    rankWeekResid:'685116200230'
  }
]
class Rank extends React.Component {
  state = {
    loading:false,
    filter:'week',
    rankWeekResid:'',
    rankAllResid:'',
    userData:{
    },
    bonusData:{
    },
    rankDataAll:[
    ],
    rankDataWeek:[
    ],
    pageIndexAll:0,
    pageIndexWeek:0
  };
  async componentDidMount() {
    let token=localStorage.getItem('AccessToken');
    if(token){
   this.getData();

    }else{
   this.props.history.push('/login')
  
  }
  }
  getData=async()=>{
    const search = document.location.search;
    const querystring = search.substring(1);
    const { eventId } = qs.parse(querystring);
    let rankResid='';
    let rankAllResid='';
    let rankWeekResid='';
    if(!eventId){
      Toast.fail('未能获取到活动');
      return false;
    }else{
      let n =0;
      while(n<mapping.length){
        if(mapping[n].eventId==eventId){
          rankResid=mapping[n].rankResid;
          rankAllResid=mapping[n].rankAllResid;
          rankWeekResid=mapping[n].rankWeekResid;
          this.setState({rankAllResid,rankWeekResid});
        }
        n++;
      }
    }
    this.setState({loading:true});
    try{
      //获取用户数据
      let res = await http().getRecordAndSubTables({
        resid:685988118358,
        subresid:rankResid,
        getsubresource: 1
      });
      if(res.data.data.length>0){
        if(res.data.data[0][rankResid].length>0){
          this.setState({bonusData:res.data.data[0][rankResid][0]});
        }
        this.setState({userData:res.data.data[0]});
        await this.getMoreData(rankWeekResid,'week');
        await this.getMoreData(rankAllResid,'all');

      }else{
        Toast.fail('未找到用户，请重新登陆')
        this.history.props.push('/login')
      }

    }catch(e){
      console.error(e);
      if(e.message=='loginerror'){
        this.props.history.push('/login');
      }
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  getMoreData=async(id,filter)=>{
    this.setState({loading:true});
    let resid='';
    let pageIndex=0;
    let _filter = this.state.filter;
    if(filter){
      _filter=filter;
    }
    if(_filter=='week'){
      resid=this.state.rankWeekResid;
      pageIndex=this.state.pageIndexWeek;
    }else{
      resid=this.state.rankAllResid;
      pageIndex=this.state.pageIndexAll;
    }
    pageIndex++;
    if(id){
      resid=id;
      pageIndex=0;
    }
    try{
      let res = await http().getTable({
        resid,
        pageIndex,
        pageSize:10
      });
      if(res.data.data.length==0){
        Toast.fail('没有更多数据了',1);
        this.setState({loading:false});
        return false
      }
      if(_filter=='week'){
        let arr =this.state.rankDataWeek;
        arr=arr.concat(res.data.data);
        this.setState({rankDataWeek:arr,loading:false,pageIndexWeek:pageIndex});
      }else{
        let arr =this.state.rankDataAll;
        arr=arr.concat(res.data.data);
        this.setState({rankDataAll:arr,loading:false,pageIndexAll:pageIndex});
      }
    }catch(e){
      console.error(e);
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  handleTouchEnd = (e) => {
    let t = document.getElementById('cal').scrollTop;
    let h = document.getElementById('cal').scrollHeight;
    let o = document.getElementById('cal').clientHeight;
    if(h==t+o){
      this.getMoreData();
    }
  };
  render() {
    return (
      <div className="ranking">
        {this.state.loading?<Loading/>:null}
       <div className='header'>
         <div className='logo' onClick={()=>{
                    this.props.history.push('/');
                  }}>主页</div>
         <div className='avatar'  onClick={()=>{
                    this.props.history.push('/user');
                  }}
                  style={this.state.userData.imgUrl?{backgroundImage:'url('+this.state.userData.imgUrl+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'contain'}:{}}
                  
                  ></div>
                  <div className='userName'
         onClick={()=>{
          this.props.history.push('/user');
        }}
        >
          {this.state.userData.memberName}
        </div>
        </div>
        <div className='container'>
              <h3>
                排名：{this.state.filter=='all'?this.state.bonusData.rankAll:this.state.bonusData.ranWeek} ---  
                积分：{this.state.filter=='all'?this.state.bonusData.bonus:this.state.bonusData.bonusWeek}
              </h3>
              <div className='total'>
                  <i  onClick={
                    ()=>{
                      this.props.history.push(this.state.bonusData.eventRoute)
                    }
                  } style={{backgroundImage:'url('+this.state.bonusData.eventIcon+')',backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat:'no-repeat'}}></i>
                  <span
                  onClick={
                    ()=>{
                      this.props.history.push(this.state.bonusData.eventRoute)
                    }
                  }
                  >{this.state.bonusData.eventName}</span>
                  <span><label onClick={()=>{
                    this.setState({filter:'week'})
                  }} className={this.state.filter=='week'?'current':''}>7日</label> <label 
                  onClick={()=>{this.setState({filter:'all'})}}
                  className={this.state.filter=='week'?'':'current'}>全部</label></span>
              </div>
              <ul
              onTouchEnd={this.handleTouchEnd}
              id='cal'
              >
          {
            this.state.filter=='week'?
            <>
            {
              this.state.rankDataWeek.map((item,index)=>{
                  return(
        <li index={index} className={this.state.filter=='week'?'ani':''} style={this.state.filter=='week'?{animationDelay:(1+index)*0.05+'s'}:{display:'none'}}>
                      <label>{item.ranWeek}</label>
                      <div style={{
                        backgroundImage:'url('+item.peopleAvatar+')',
                        backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',
                        backgroundPosition:'center',
                        backgroundColor:'#eee'
                      }}></div>
                      <span>{item.peopleName}</span>
                      <span>{item.bonusWeek}分</span>
                    </li>
                  )
              }
                
              )
            }
            </>
            :
            <>
            {
              this.state.rankDataAll.map((item,index)=>{
                  return(
                    <li index={index} className={this.state.filter=='week'?'':'ani2'} style={this.state.filter=='all'?{animationDelay:(1+index)*0.05+'s'}:{display:'none'}}>
                      <label>{item.rankAll}</label>
                      <div style={{
                        backgroundImage:'url('+item.peopleAvatar+')',
                        backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',
                        backgroundPosition:'center',
                        backgroundColor:'#eee'
                      }}>
                      </div>
                      <span>{item.peopleName}</span>
                      <span>{item.bonus}分</span>
                    </li>
                  )
              }
                
              )
            }
            </>
          }
        </ul>
        </div>
        
        <div className='mainBtn' onClick={()=>{
                    this.props.history.push(this.state.bonusData.eventRoute);
                  }}>
          前往{this.state.bonusData.eventName}
        </div>
      </div>
    );
  }
}

export default Rank;
